
import { Label } from "@/components/ui/label";
import { EnhancedUploadArea } from "../../storage/EnhancedUploadArea";
import { useImageUpload } from "@/hooks/useImageUpload";
import { getStorageUrl } from "@/utils/storageUtils";

interface ActivityFileUploadProps {
  label: string;
  currentPath?: string;
  onPathChange: (path: string) => void;
  onUploadStateChange?: (uploading: boolean) => void;
  disabled?: boolean;
}

export const ActivityFileUpload = ({
  label,
  currentPath = "",
  onPathChange,
  onUploadStateChange,
  disabled = false,
}: ActivityFileUploadProps) => {
  const { uploading, uploadFile } = useImageUpload({
    bucketName: "activities",
    onPathChange,
    currentPath,
    onUploadStateChange,
  });

  const handleFileUpload = (file: File) => {
    uploadFile(file);
  };

  const handleFileSelect = (bucketName: string, fileName: string) => {
    const path = `/${fileName}`;
    onPathChange(path);
  };

  const handlePathChange = (path: string) => {
    onPathChange(path);
  };

  return (
    <div className="space-y-2">
      <Label>{label}</Label>
      <EnhancedUploadArea
        label=""
        onFileUpload={handleFileUpload}
        onFileSelect={handleFileSelect}
        onPathChange={handlePathChange}
        uploading={uploading}
        acceptedTypes={[
          'application/pdf',
          'application/msword',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          'image/jpeg',
          'image/png',
          'image/gif'
        ]}
        allowedBuckets={['activities']}
        showBrowseOption={true}
        showPathInput={true}
        currentPath={currentPath}
      />
    </div>
  );
};
